<script>
    import { createEventDispatcher, onMount, tick } from 'svelte';
    import * as findingService from './v2-service.js';
    import { notificate } from '../../services/notification.js';
    import { form as svForm, field } from "svelte-forms";
    import { required } from 'svelte-forms/validators';
    import CustomPropsFormElement from '../../components/custom-props-form-element.svelte';
    import { format } from 'svelte-i18n';

    const dispatch = createEventDispatcher();

    export let customProps = [{}];
    export let finding_id;

    let formIsSubmitted = false;
    // API string errors
    let APIerror = null;
    // API 422 errors
    let formApiErrors = {};
    let props_errors;

    // errors must be shown only when:
    //   field is invalid (dirty or after submit)
    //   or the API returned 422
      function shouldShowFieldError(field) {
        return (
            ((formIsSubmitted || field.dirty) && !field.valid)
            || (formApiErrors[field])
        );
    }

    function handleSubmit() {

        formIsSubmitted = true;
        // reset API errors
        formApiErrors = {};

        for(let prop of customProps){
            if(!prop.kind || !prop.name){
                props_errors = 'No se pudo guardar el hallazgo debido a que las propiedades deben tener tipo y nombre. Por favor, complete los campos e intente nuevamente.'
                return false;
            }
            if(Object.keys(prop).length > 0){
                let propReqData = {
                    finding_id: finding_id,
                    name      : prop.name,
                    value     : prop.value ? prop.value : null,
                    kind      : prop.kind,
                    location  : prop.location,
                }

                findingService.saveProp(propReqData, [], {})
                    .then(response=>dispatch("saveProp"))
                    .catch(error=>dispatch("saveProp"))
                ;
            }
        }
    }


    function handleCloseModal(){
        customProps     = [{}]
        formApiErrors   = {};
        APIerror        = null;
        formIsSubmitted = false;
        props_errors    = false;
        
        // THIS WAS MISSING: Tell the parent to actually close the modal!
        dispatch('cancel'); 
    }

    const addCustomPropInput = () =>{
        customProps.push({});
        customProps = customProps;
    }

    const removeCustomPropInput = (event) =>{
        let i = event.detail;
        customProps.splice(i, 1);
        customProps = customProps;
    }

    const pushCustomProps = (event) =>{
        customProps = event.detail;
    }

    const handleKeydown = event => {

        if(event.key == "Escape"){
            handleCloseModal();
        }
        else {
            return;
        }
    }
</script>
<style>
    select {
        max-width: 400px;
    }
</style>

<svelte:window on:keydown={handleKeydown}/>

<form role="form" novalidate on:submit|preventDefault={()=>handleSubmit()}>
    <div class="card">
        <div class="card-body">
            <div class="mb-3">
                {#key customProps}
                    <CustomPropsFormElement customProps={customProps ? customProps : [{}]} on:addCustomProp={addCustomPropInput} on:pushCustomProps={pushCustomProps} on:removeCustomProp={removeCustomPropInput} />
                    {#if props_errors}
                        <div class="text-danger">{props_errors}</div>
                    {/if}
                {/key}
            </div>
        </div>

        <div class="card-footer">
            <button id="customFindingAddSubmit" type="submit" class="btn btn-primary">{$format("buttons.add")}</button>
            <!-- REMOVED data-bs-dismiss="modal" so Svelte controls the closing -->
            <button type="button" class="btn btn-default" on:click={handleCloseModal}>{$format("buttons.cancel")}</button>
        </div>
    </div>
</form>